export default "__VITE_ASSET__e9bdc618__"